var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudioLogo = function SvgStudioLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 .16A.16.16 0 0 1 .16 0h19.68a.16.16 0 0 1 .16.16v19.68a.16.16 0 0 1-.16.16H.16a.16.16 0 0 1-.16-.16V.16Zm9.999 2.841a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z",
    fill: "#fff"
  })));
};
export default SvgStudioLogo;